<template>
  <div class="wrapper padding-lr-sm">
    <div class="flex align-center justify-between margin-bottom-sm">
      <div class="flex align-center ">
        <el-input v-model="keyword" placeholder="请输入社会组织名称" class=" margin-right-sm"></el-input>
        <el-button type="primary" @click="hanldSearch">搜索</el-button>
      </div>

      <el-button type="primary" round @click="orgDialog = true">创建社会组织</el-button>

    </div>
    <el-table
      :data="orgList"
      header-row-class-name="table-header"
      row-class-name="table-row"
      alig="center"
      border
      style="width: 100%"
    >
      <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
      <el-table-column label="社会组织名称" prop="title"></el-table-column>
      <el-table-column label="统一社会信用代码" prop="credit_code"></el-table-column>
      <el-table-column width="120" label="联系人" prop="name"></el-table-column>
      <el-table-column width="120" label="联系人电话" prop="phone"></el-table-column>
      <el-table-column width="130" label="状态">
        <template slot-scope="scope">
          <div class="flex align-center justify-center" @click="statusItem(scope.row.id,scope.row.status)">
            <span>{{ scope.row.status === 0 ? "正常" : "已锁定" }}</span>
            <el-switch
              style="display: block"
              :value="scope.row.status"
              :active-value="0"
              :inactive-value="1"
              active-color="#368ad1"
              inactive-color="#999999"
            >
            </el-switch>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="180" label="操作">
        <template slot-scope="scope">
          <div class="table-operate">
            <div class="flex align-center justify-between margin-bottom-xs">
              <el-button size="medium" type="primary" plain @click="editItem(scope.row)">编辑</el-button>
              <el-button size="medium" type="danger" @click="deleteItem(scope.row.id)">删除</el-button>
            </div>

          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="orgList.length > 0"
      class="page-all"
      background
      @current-change="getList"
      :current-page.sync="page"
      :page-size="limit"
      layout="prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <orgDialog
      :setId="setId"
      :setItem="setItem"
      :orgDialog="orgDialog"
      @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import {orgDel, orgList, setOrgStatus} from "@/api/admin";
import orgDialog from "@/views/admin/dialog/orgDialog";

export default {
  name: "OrgList",
  data() {
    return {
      keyword: '',
      page: 1,
      limit: 10,
      total: 0,
      orgList: [],
      orgDialog: false,
      setId: 0,
      setItem: {},
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "社会组织管理", false);
    this.getList()
  },
  components: {
    orgDialog
  },
  methods: {
    //  修改状态
    statusItem(id, status) {
      this.$confirm('您确定要' + (status === 0 ? '锁定' : '解锁') + '该社会组织信息吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureSet(id, status);
      });
    },
    async sureSet(id, status) {
      let _state = await setOrgStatus(id, status === 0 ? 1 : 0);
      await this.getList();
      this.$message.success(_state.msg);
    },
    //  编辑
    editItem(obj) {
      this.setItem = obj;
      this.setId = obj.id;
      this.orgDialog = true;
    },
    //  员工信息编辑后回调
    cancelDialog() {
      this.setId = 0;
      this.setItem = {};
      this.orgDialog = false;
      this.getList()
    },
    //  删除
    deleteItem(id) {
      this.$confirm('您确定要删除该社会组织信息吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await orgDel(id);
      if (this.orgList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getList();
      this.$message.success(_state.info);
    },
    //  搜索
    hanldSearch() {
      this.page = 1
      this.getList()
    },
    //  获取打分表列表
    async getList() {
      const res = await orgList(this.keyword, this.page, this.limit)
      this.orgList = res.data.data
      this.total = res.data.total
    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
